import { Inject, Injectable } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { NightModeService } from "./night-mode.service";
import { ThemesService } from "./themes.service";
import { BehaviorSubject, combineLatest, Subject } from "rxjs";
import { DOCUMENT } from "@angular/common";
import { AppViewVar } from "@model";

@Injectable({ providedIn: "root" })
export class MetaThemeColorService {
  private _externallyDemandedColorVar = new BehaviorSubject<AppViewVar | null>(null);
  private _themeColor$ = new Subject<string>();

  constructor(
    private _meta: Meta,
    @Inject(DOCUMENT) private _document: Document,
    private _nightModeService: NightModeService,
    private _themesService: ThemesService,
  ) {
    combineLatest([
      this._nightModeService.isNightMode$,
      this._themesService.currentTheme$,
    ]).subscribe(([isNightMode]) => {
      this._setThemeColor(isNightMode);
    });

    combineLatest([
      this._externallyDemandedColorVar,
      this._themeColor$,
      this._nightModeService.isNightMode$,
    ]).subscribe(([externalColorVar, themeColor]) => {
      if (!externalColorVar) {
        this._setMetaThemeColor(themeColor);
      } else {
        const color = this._themesService.getAppViewColor(externalColorVar);
        this._setMetaThemeColor(color);
      }
    });
  }

  private _setThemeColor(isNightMode: boolean): void {
    const color = getComputedStyle(this._document.documentElement).getPropertyValue(
      isNightMode ? "--body-background-color-dark" : "--body-background-color-light",
    );
    this._themeColor$.next(color);
  }

  private _setMetaThemeColor(color: string) {
    this._meta.updateTag({ name: "theme-color", content: color });
  }

  setDemandOnMetaColor(color: AppViewVar | null) {
    this._externallyDemandedColorVar.next(color);
  }
}
